__turbopack_context__.v({
  "className": "basiersquare_81a30a53-module__ttmmSW__className",
  "variable": "basiersquare_81a30a53-module__ttmmSW__variable",
});
